module.exports = __webpack_public_path__ + "img/932996879.b1ebaa30.jpg";